import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Button from "@material-ui/core/Button";

import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import ExamFilterForm from "../../ExamFilterForm/ExamFilterForm";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { connect } from "react-redux";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomEmptyMessage from "../../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import PublishingBody from "../PublishingBody/PublishingBody";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import PublishClassDetails from "../PublishClassDetails/PublishClassDetails";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewPublishMarks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Student Name" },
        { name: "Publish Status" },
        { name: "Attendance" },
        { name: "Result" },
      ],

      rowsPerPage: 5,
      page: 0,
      data: {
        session: new Date().getFullYear().toString(),
        exam: "",
        section: "",
        class: "",
        faculty: "",
        group: "",
      },
      showData: false,
      isEmpty: false,
      results: [],
      studentIds: [],
      idsError: "",
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      showData: false,
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeClass = (e) => {
    this.setState({
      showData: false,
      data: {
        ...this.state.data,
        class: e.target.value,
        section: "",
        faculty: "",
        group: "",
      },
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.getResults();
  };

  getResults = async () => {
    try {
      this.setState({ loading: true });
      const response = await Axios.get(`${url}/api/marks`, {
        params: {
          session: this.state.data.session,
          examType: this.state.data.exam,
          studentClass: this.state.data.class,
          faculty: this.state.data.faculty ? this.state.data.faculty : null,
          group: this.state.data.group ? this.state.data.group : null,
          section: this.state.data.section,
        },
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.marks.length !== 0) {
        this.setState({
          results: response.data.marks,
          showData: true,
          isEmpty: false,
          loading: false,
        });
      } else {
        this.setState({
          results: [],
          showData: false,
          isEmpty: true,
          loading: false,
        });
      }
    } catch (error) {
      this.setState({ loading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getResults();
      }
    }
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleSelectAllClick = (e) => {
    if (e.target.checked) {
      const newSelected = this.state.results.map((data) => data._id);
      this.setState({
        studentIds: newSelected,
      });
      return;
    }
    this.setState({
      studentIds: [],
    });
  };

  handleClick = (studentIds) => {
    this.setState({
      studentIds,
    });
  };

  checkError = () => {
    let idsError = "";
    if (this.state.studentIds.length === 0) {
      idsError = "Please select one student's results to be published";
    }

    if (idsError) {
      this.setState({
        idsError,
      });
      return true;
    } else {
      this.setState({ idsError: "" });
      return false;
    }
  };

  handlePublish = async () => {
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        const response = await Axios.put(
          `${url}/api/marks/publish`,
          { studentIds: this.state.studentIds },
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (response.data.message === "Published successfully") {
          this.getResults();
        }
      } catch (error) {
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handlePublish();
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Publish Marks" refreshUrl={this.props.match.url} />

          <ExamFilterForm
            loading={this.state.loading}
            buttonLabel="Get Results"
            data={this.state.data}
            handleChangeClass={this.handleChangeClass}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
          {this.state.showData && this.state.results.length !== 0 ? (
            <>
              <PublishClassDetails data={this.state.data} />
              <div
                style={{ padding: 10, display: "flex", alignItems: "center" }}
              >
                <Button variant="outlined" onClick={this.handlePublish}>
                  Publish
                </Button>
                {this.state.idsError && (
                  <div style={{ marginLeft: 10, color: "red" }}>
                    {this.state.idsError}
                  </div>
                )}
              </div>
              <TableContainer>
                <Table>
                  <CustomTableHead
                    column={this.state.column}
                    showCheckbox={true}
                    numSelected={this.state.studentIds.length}
                    onSelectAllClick={this.handleSelectAllClick}
                    rowCount={this.state.results.length}
                  />
                  <TableBody>
                    {(rowsPerPage > 0
                      ? this.state.results.slice(
                          rowsPerPage * page,
                          rowsPerPage * page + rowsPerPage
                        )
                      : this.state.results
                    ).map((result, index) => (
                      <PublishingBody
                        key={index}
                        index={index}
                        data={result}
                        handleClick={this.handleClick}
                        studentIds={this.state.studentIds}
                      />
                    ))}
                  </TableBody>

                  <CustomTableFooter
                    count={this.state.results.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handlePage}
                    onChangeRowsPerPage={this.handleRowsPerPage}
                  />
                </Table>
              </TableContainer>
            </>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage description="Marks are not configured for this class's students" />
          ) : (
            <CustomEmptyMessage description="Please Fill above form" />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(ViewPublishMarks));
